import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';
import {
  DEFAULT_SMS_QUIET_HOURS_END,
  DEFAULT_SMS_QUIET_HOURS_START,
  ensureSmsComplianceBody,
  getSmsBlockReason,
} from './compliance';

export async function sendTenantSms({
  tenant,
  propertyId,
  message,
  templateKey = 'custom',
  channel = 'sms',
  lang,
  includePaymentLink,
  quietHoursStart = DEFAULT_SMS_QUIET_HOURS_START,
  quietHoursEnd = DEFAULT_SMS_QUIET_HOURS_END,
}) {
  const blockReason = getSmsBlockReason(tenant, quietHoursStart, quietHoursEnd);
  if (blockReason) {
    throw new Error(blockReason);
  }

  const finalLang = lang || tenant?.preferredLanguage || 'en';
  const sendSms = httpsCallable(functions, 'sendSMS');
  const result = await sendSms({
    phone: tenant.phone,
    message: ensureSmsComplianceBody(message, finalLang),
    tenantId: tenant.id,
    propertyId,
    templateKey,
    channel,
    lang: finalLang,
    includePaymentLink: includePaymentLink ?? ((tenant?.currentBalance || 0) > 0),
  });

  return result.data;
}
